import screens from '../common/screens';
import DecisionRouter from './DecisionRouter';

import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import MapElementModal from '../../../graph/MapElementModal';
import {
    type MapElementConfigProps,
    MapElementProvider,
} from '../contextProviders/MapElementProvider';

const Decision = (props: MapElementConfigProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.decision}
            elementType={MAP_ELEMENT_TYPES.decision}
            isLoading={false}
        >
            <MapElementModal>
                <DecisionRouter />
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Decision;
